import { Control, Controller } from "react-hook-form";
import { NoxusFormLabel } from "./NoxusFormLabel";
import { Switch } from "../shadcn/switch";

interface IToggleField {
  name: string;
  defaultValue?: boolean;
  control?: Control<any>;
  label?: string | React.ReactNode;
  description?: string;
  tooltip?: string;
  isDisabled?: boolean;
  required?: boolean;
  togglePosition?: "left" | "right";
}
interface IToggle {
  name?: string;
  value: boolean;
  onChange: (value: boolean) => void;
  tooltip?: string;
  label?: string | React.ReactNode;
  description?: string;
  isDisabled?: boolean;
  togglePosition?: "left" | "right";
}

const ToggleContent = ({
  label,
  description,
  tooltip,
  name,
}: {
  label?: string | React.ReactNode;
  description?: string;
  tooltip?: string;
  name?: string;
}) => {
  if (!label && !description) return null;
  return (
    <div className="flex-1 min-w-0">
      {label && (
        <NoxusFormLabel label={label} tooltip={tooltip} name={name} noMargin />
      )}
      {description && (
        <p className="text-xs text-muted-foreground mt-1">{description}</p>
      )}
    </div>
  );
};

export const Toggle = ({
  name,
  value,
  onChange,
  tooltip,
  label,
  description,
  isDisabled,
  togglePosition = "right",
}: IToggle) => {
  const switchEl = (
    <Switch
      id={name}
      checked={value}
      onCheckedChange={onChange}
      disabled={isDisabled}
      className="shrink-0"
    />
  );

  if (togglePosition === "left") {
    return (
      <div className="flex items-center gap-3">
        {switchEl}
        <ToggleContent
          label={label}
          description={description}
          tooltip={tooltip}
          name={name}
        />
      </div>
    );
  }

  return (
    <div className="flex justify-between items-start gap-4">
      <ToggleContent
        label={label}
        description={description}
        tooltip={tooltip}
        name={name}
      />
      {switchEl}
    </div>
  );
};

export const ToggleField = ({
  name,
  defaultValue,
  tooltip,
  label,
  description,
  control,
  isDisabled,
  required,
  togglePosition = "right",
}: IToggleField) => {
  return (
    <Controller
      rules={{ required }}
      defaultValue={defaultValue}
      control={control}
      disabled={isDisabled}
      render={({ field }) => (
        <Toggle
          name={name}
          value={field.value}
          onChange={field.onChange}
          tooltip={tooltip}
          label={label}
          description={description}
          isDisabled={isDisabled}
          togglePosition={togglePosition}
        />
      )}
      name={name}
    />
  );
};
